import {
    CLEAR_SUBSCRIBE_VEHICLE, SET_MEDIA_DIALOG, SET_EVENT_DIALOG, SUBSCRIBE_VEHICLE, UNSUBSCRIBE_VEHICLE
} from "@/store/modules/media/mutations";

const subscribeVehicle = ({ commit }, payload) => {
    commit(SUBSCRIBE_VEHICLE, payload)
};

const unsubscribeVehicle = ({ commit }, payload) => {
    commit(UNSUBSCRIBE_VEHICLE, payload)
};

const clearSubscriptionVehicle = ({ commit }) => {
    commit(CLEAR_SUBSCRIBE_VEHICLE);
};

const setMediaDialog  = ({ commit }, payload) => {
    commit(SET_MEDIA_DIALOG, payload)
};

const setEventDialog  = ({ commit }, payload) => {
    commit(SET_EVENT_DIALOG, payload)
};

export default {
    subscribeVehicle,
    unsubscribeVehicle,
    clearSubscriptionVehicle,
    setMediaDialog,
    setEventDialog
};
